<template>
	<VPopup
		ref="popup"
		class="order-position-payment-terms-popup"
		position="bottom"
		align="left"
		show-pointer
		:offset="17"
		:visible="true"
		:target="target"
	>
		<ul v-if="position">
			<li>
				<header>Дата заказа:</header>
				<div>{{ $core.utils.date.format(position.createdAt) }}</div>
			</li>
			<li>
				<header>Жел. дата получения:</header>
				<div>{{ $core.utils.date.format(position.desiredReceiptDate) }}</div>
			</li>
			<li>
				<header>План. дата отгрузки:</header>
				<div>{{ $core.utils.date.format(position.plannedShipmentDate) }}</div>
			</li>
			<li>
				<header>План. дата оплаты:</header>
				<div>{{ $core.utils.date.format(position.plannedPaymentDate) }}</div>
			</li>
			<li>
				<header>Условие оплаты:</header>
				<div>
          <template v-if="position.prepaymentTerms">
            <div v-for="paymentTerm in position.prepaymentTerms">
              {{ paymentTerm.stringRepresentation }}
            </div>
          </template>
          <template v-if="position.postpaymentTerms">
            <div v-for="paymentTerm in position.postpaymentTerms">
              {{ paymentTerm.stringRepresentation }}
            </div>
          </template>
				</div>
			</li>
			<li>
				<header>Комментарий:</header>
				<div class="comment">
					{{ position.offer?.description || '--' }}
				</div>
			</li>
		</ul>
	</VPopup>
</template>

<script lang="ts">
import type OrderPosition from '@/domains/Orders/OrderPosition';

export default defineComponent({
	name: 'OrderPositionPaymentTermsPopup',

	props: {
		position: {
			type:    Object as PropType<OrderPosition>,
			default: null,
		},
		target: {
			type:    [String, HTMLElement, Object],
			default: null,
		},
	},
});
</script>

<style lang="scss" src="./OrderPositionPaymentTermsPopup.scss"/>
